export default "__VITE_ASSET__UKzXTFGR__"